import En from '../../constants/language/En.json'
import Es from '../../constants/language/Es.json'
import Fr from '../../constants/language/Fr.json'
import Pt from '../../constants/language/Pt.json'

const MESSAGES: Record<string, Record<string, string>> = {
  en: En,
  fr: Fr,
  es: Es,
  pt: Pt,
}

/**
 * Translate a message key for a given locale.
 * Falls back to English, then returns the key itself.
 */
export const t = (key: string, locale = 'en'): string => {
  const messages = (
    MESSAGES as Partial<Record<string, Record<string, string>>>
  )[locale]
  const enMessages = MESSAGES.en as Partial<Record<string, string>>
  const resolved = messages?.[key] ?? enMessages[key]
  return resolved ?? key
}
